// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cuestionario{
    margin: 20px;
}

.headersMargin{
    margin: 3% 20%;
}

.scroll-pane {
    margin-top: 25px;
    max-height: 600px;
    overflow-y: auto;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}

.card-header{
    background-color: #dc3545;
}

.card-title{
    color: white;
}

.box{
    float: left;
    margin-right: 40px;
    text-align: center;
}   
.small{
    width: 50px;
}
.large{
    width: 100px;
}

.borderlessInput{
    text-align:center; 
    background:transparent; 
    border:none;
}


.container {
    /*max-width: 800px;*/
    margin: auto;
}
.form-group {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}
.form-group label {
    font-weight: bold;
}
.input-small {
    width: 60px;
    text-align: center;
}
.sugerencias {
    background: #f0f0f0;
    padding: 15px;
    border-radius: 5px;
    margin-top: 20px;
    max-width: 500px;
}
.sugerencias strong {
    display: block;
}

.smallInput{
    width: 55px;
    text-align: center;/*
    background: transparent;
    border: none;*/
}

.mediumInput{
    width: 80px;
    /*text-align: center;
    background: transparent;
    border: none;*/
}

.card-seccion{
    border: 1px solid #ccc !important;
    border-radius: 5px;
    margin-bottom: 20px;
}

.separador{
    border: 1px solid #ccc;
    margin: 30px 0;
}

.img-tipo-cuerpo {
    max-height: 250px;
}

.img-musculo{
    max-height: 120px;
}

.img-lados{
    max-height: 300px;
    max-width: 225px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/cuestionario-cliente/cuestionario-cliente.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;AACf;;;AAGA;IACI,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB,CAAC;;kBAEL;AAClB;;AAEA;IACI,WAAW;IACX;;kBAEc;AAClB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".cuestionario{\n    margin: 20px;\n}\n\n.headersMargin{\n    margin: 3% 20%;\n}\n\n.scroll-pane {\n    margin-top: 25px;\n    max-height: 600px;\n    overflow-y: auto;\n    border-top: 1px solid #ccc;\n    border-bottom: 1px solid #ccc;\n}\n\n.card-header{\n    background-color: #dc3545;\n}\n\n.card-title{\n    color: white;\n}\n\n.box{\n    float: left;\n    margin-right: 40px;\n    text-align: center;\n}   \n.small{\n    width: 50px;\n}\n.large{\n    width: 100px;\n}\n\n.borderlessInput{\n    text-align:center; \n    background:transparent; \n    border:none;\n}\n\n\n.container {\n    /*max-width: 800px;*/\n    margin: auto;\n}\n.form-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n.form-group label {\n    font-weight: bold;\n}\n.input-small {\n    width: 60px;\n    text-align: center;\n}\n.sugerencias {\n    background: #f0f0f0;\n    padding: 15px;\n    border-radius: 5px;\n    margin-top: 20px;\n    max-width: 500px;\n}\n.sugerencias strong {\n    display: block;\n}\n\n.smallInput{\n    width: 55px;\n    text-align: center;/*\n    background: transparent;\n    border: none;*/\n}\n\n.mediumInput{\n    width: 80px;\n    /*text-align: center;\n    background: transparent;\n    border: none;*/\n}\n\n.card-seccion{\n    border: 1px solid #ccc !important;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.separador{\n    border: 1px solid #ccc;\n    margin: 30px 0;\n}\n\n.img-tipo-cuerpo {\n    max-height: 250px;\n}\n\n.img-musculo{\n    max-height: 120px;\n}\n\n.img-lados{\n    max-height: 300px;\n    max-width: 225px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
